var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33268 6.66667C2.33268 4.89856 3.03506 3.20286 4.2853 1.95262C5.53555 0.702379 7.23124 0 8.99935 0C10.7675 0 12.4632 0.702379 13.7134 1.95262C14.9636 3.20286 15.666 4.89856 15.666 6.66667V10.5808L17.3327 13.0808V16.6667H12.6568C12.4673 17.4948 12.0023 18.234 11.338 18.7635C10.6736 19.2929 9.84928 19.5812 8.99977 19.5812C8.15025 19.5812 7.32589 19.2929 6.66155 18.7635C5.99721 18.234 5.53223 17.4948 5.34268 16.6667H0.666016V13.0808L2.33268 10.5808V6.66667ZM7.08935 16.6667C7.25133 17.0385 7.51835 17.355 7.85764 17.5773C8.19693 17.7996 8.59373 17.918 8.99935 17.918C9.40497 17.918 9.80177 17.7996 10.1411 17.5773C10.4803 17.355 10.7474 17.0385 10.9093 16.6667H7.08935ZM8.99935 1.66667C7.67327 1.66667 6.4015 2.19345 5.46382 3.13113C4.52613 4.06881 3.99935 5.34058 3.99935 6.66667V11.0858L2.33268 13.5858V15H15.666V13.5858L13.9993 11.0858V6.66667C13.9993 5.34058 13.4726 4.06881 12.5349 3.13113C11.5972 2.19345 10.3254 1.66667 8.99935 1.66667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationLogo);
export default __webpack_public_path__ + "static/media/notificationLogo.97fc24b314ec687cef27fc95d39377f2.svg";
export { ForwardRef as ReactComponent };